import rangeSlider from "range-slider-input";
import 'range-slider-input/dist/style.css';
import Choices from "choices.js";
import "choices.js/public/assets/styles/choices.css";

const table = document.getElementById('apartment-table');

if (table !== null) {
  function getRowValues(row) {
    const cells = {};

    Array.from(row.querySelectorAll('td')).forEach(cell => {
      const key = cell.dataset.key;
      cells[key] = cell;
    });

    return {
      name: cells['name'].textContent,
      floor: cells['floor'].textContent.match(/[0-9]+/)?.[0] ?? "0",
      powierzchnia: parseFloat(cells['size'].textContent.match(/[0-9.]+/)?.[0] ?? "0"),
      cena: parseFloat(cells['price']?.textContent?.replaceAll(/[^0-9]+/g, "")),
      isAvailable: ['wolne'].includes(cells['status'].querySelectorAll('strong')?.[0].textContent.trim()),
    };
  }

  function filter() {
    rows.forEach(row => {
      let isDisabled = false;

      if (
        state.floor !== "" &&
        row.values.floor !== state.floor
      ) isDisabled = true;

      if (
        row.values.powierzchnia < state.powierzchnia[0] ||
        Math.floor(row.values.powierzchnia) > state.powierzchnia[1]
      ) isDisabled = true;


      if (
        row.values.cena < state.cena[0] ||
        row.values.cena > state.cena[1] ||
        (
          row.values.cena !== "" &&
          isNaN(row.values.cena) &&
          (
            state.cena[0] > window.apartments.price.min ||
            state.cena[1] < window.apartments.price.max
          )
        )
      ) isDisabled = true;

      if (state.onlyAvailable && !row.values.isAvailable) isDisabled = true;

      if (row.isDisabled !== isDisabled) {
        row.isDisabled = isDisabled;
        if (isDisabled) row.element.classList.add('disabled');
        else row.element.classList.remove('disabled');
      }
    });
  }

  function initPowierzchniaRange() {
    const powierzchniaRange = rangeSlider(document.getElementById('powierzchnia-range'), {
      min: apartments.size.min,
      max: apartments.size.max,
      value: [apartments.size.min, apartments.size.max],
      rangeSlideDisabled: true,
      onInput: value => {
        if (isManualEdit) {
          isManualEdit = false;
        } else {
          document.getElementById('powierzchnia-range-min').textContent = value[0];
          document.getElementById('powierzchnia-range-max').textContent = value[1];
        }
        state.powierzchnia = value;
        filter();
      }
    });

    document.getElementById('powierzchnia-range-min').addEventListener('input', event => {
      const prev = powierzchniaRange.value();
      isManualEdit = true;
      powierzchniaRange.value([event.currentTarget.textContent, prev[1]]);
    });

    document.getElementById('powierzchnia-range-max').addEventListener('input', event => {
      const prev = powierzchniaRange.value();
      isManualEdit = true;
      powierzchniaRange.value([prev[0], event.currentTarget.textContent]);
    });
  }

  // function initCenaRange() {
  //   const cenaRange = rangeSlider(document.getElementById('cena-range'), {
  //     min: apartments.price.min,
  //     max: apartments.price.max,
  //     step: 1000,
  //     value: [apartments.price.min, apartments.price.max],
  //     rangeSlideDisabled: true,
  //     onInput: value => {
  //       if (isManualEdit) {
  //         isManualEdit = false;
  //       } else {
  //         document.getElementById('cena-range-min').textContent = value[0];
  //         document.getElementById('cena-range-max').textContent = value[1];
  //       }
  //       state.cena = value;
  //       filter();
  //     }
  //   });

  //   document.getElementById('cena-range-min').addEventListener('input', event => {
  //     const prev = cenaRange.value();
  //     isManualEdit = true;
  //     cenaRange.value([event.currentTarget.textContent, prev[1]]);
  //   });

  //   document.getElementById('cena-range-max').addEventListener('input', event => {
  //     const prev = cenaRange.value();
  //     isManualEdit = true;
  //     cenaRange.value([prev[0], event.currentTarget.textContent]);
  //   });
  // }

  function initAvailableCheckbox() {
    const element = document.getElementById('available-checkbox');
    element.addEventListener('input', event => {
      state.onlyAvailable = event.currentTarget.checked;
      filter();
    });
  }

  function initFloorDropdown() {
    const element = document.getElementById('floor-dropdown');
    new Choices(element, {
      searchEnabled: false,
      placeholderValue: 'wybierz piętro',
      itemSelectText: '',
      removeItemButton: true,
    });

    element.addEventListener('change', event => {
      const value = event.currentTarget.value;
      state.floor = value.toString();
      filter();
    });
  }

  const apartments = window.apartments;
  const rows = Array.from(table.querySelectorAll('tr:nth-child(n+2)')).map(element => ({
    element,
    values: getRowValues(element),
  }));
  const state = {
    floor: "",
    powierzchnia: [apartments.size.min, apartments.size.max],
    cena: [apartments.price.min, apartments.price.max],
    onlyAvailable: false,
  };

  let isManualEdit = false;

  initPowierzchniaRange();
  // initCenaRange();
  initAvailableCheckbox();
  initFloorDropdown();
}
